import "lazysizes";
import { onDocumentReady } from "./utils/document-ready";

import Link from "./components/link";
import Dialog from "./components/dialog";
import Section from "./components/section";
import { ClientComponentManager } from "./utils/client-component-manager";

onDocumentReady(() => {
  /**
   * Synchronous components: Import and use the class.
   * @example new ClientComponentManager(Component, "selector");
   */
  new ClientComponentManager(Link, "a");
  new ClientComponentManager(Dialog, ".js--dialog");
  new ClientComponentManager(Section, ".js--section");

  /**
   * Asynchronous components: Provide file handle in /js/components/ directory.
   * @example new ClientComponentManager('component', "selector");
   */
  new ClientComponentManager("grid", ".js--grid");
  new ClientComponentManager("accordion", ".js--accordion");
  new ClientComponentManager("carousel", ".js--carousel");
  new ClientComponentManager("embed", ".js--embed");
  new ClientComponentManager("video", ".js--video");
  new ClientComponentManager("tooltip", ".js--tooltip");
  new ClientComponentManager("grants-table", ".gv-gt");
});
